<!-- 登录页 -->
<template>
  <div class="webcardbindMain">
    <div class="webwrapCardBody" style="max-height:400px; overflow-y:auto; " v-if="!qrcodeFlag">
      <div class="Hseat"></div>
      <div class="inputForm">
        <div class="telDivCard">
          <i class="iconfont iconiconfontshouji"></i>
          <!-- pswWidth1 -->
          <input class="pswWidth1" type="text" placeholder="请输入卡号" v-model="cardNumber" />
           <i class="iconfont iconscan" style="float: right" @click="scancode"></i>
        </div>
        <div class="telDivCard tel_passworld">
          <i class="iconfont iconsuo"></i>
          <input :type="eysTrue ? 'password' : 'text' " placeholder="电子码或密码8-12位不区分大小写" v-model="cardPwd" class="pswWidth1">
          <i :class="['iconfont', eysTrue ? 'icon-eyeopen' : 'icon-eyeclose']" style="float: right" @click="() => eysTrue = !eysTrue"></i>
        </div>
        <div class="clearBoth"></div>
         <!-- v-if="codeNum >= 3" -->
        <div class="telDivCard">
          <i class="iconfont iconiconfont5"></i>
          <input class="pswWidth" type="text" placeholder="请输入验证码" v-model="code" />
          <img :src="imgUrl" @click="getCode" />
        </div>
        <div class="Hseat"></div>
      </div>
      <div class="loginBtnCard" @click="login">确定</div>
      <div class="agremmentCard">
        <p>温馨提示：如果只有密码，无需填写第一个输入框内容</p>
      </div>
    </div>
    <Bounced
      type="confirm"
      @took="queRenOk"
      @tocancel="queRenOk"
      :showstate="showDio"
    >
      <span slot="tlt">温馨提示</span>
      <div slot="text">虎卡您已绑卡成功！<br/> 同时赠送您两项权益：<br/> 1.电影plus的商家同等面值的报销金额度 <br/> 2.赠送超值的品牌抵扣券</div>
    </Bounced>
  </div>
</template>
<script>
import * as api from '@/api'
import JmmToast from '@/components/JmmToast'
import wx from 'weixin-js-sdk'
import '@/assets/stylecss/iconfont.css'
import Bounced from "@/components/Bounced";
var Base64 = require('js-base64').Base64
export default {
  name: 'login',
  data() {
    return {
      showDio: false, // 模态框
      eysTrue: true,     // 密码框 显示小眼睛
      token: 'jjcimpilpgejfeehkdinjlbgabbgchhe',
      sign: '',
      cardNumber: '',
      cardPwd: '',
      code: '',
      scanlinks: '',
      businessid: '',
      imgUrl: '',
      imageCode: '',
      cardrights: '',     
      codeNum:0,             //如果大于等于3显示验证码否则不显示 
      channel: '',           // 判断渠道ID     
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.sign = this.$route.query.sign ? this.$route.query.sign : localStorage.getItem('codeSign');
    //判断渠道ID
    this.channel = this.$route.query.channel;
    if(null == this.channel || undefined == this.channel){
      this.channel = '';
    }
  },
  mounted () {
  },
  components: { JmmToast,Bounced },
  methods: {
    queRenOk(){
      this.showDio = false;
      let toUrl = `tigerCardLoginList.html#/?merchantId=${this.merchantId}&channel=${this.channel}&timer=${new Date().getTime()}`;
      window.location.href = toUrl;
    },
    cardBackpage() {
      // let toUrl = `${decodeURIComponent(localStorage.getItem('return_url1'))}&timer=${new Date().getTime()}`
      //  window.location.href = toUrl
    },
    // 图形验证码
    async getCode() {
      try {
        let data = await api.user.getCode(this.sign, 'img')
        this.imgUrl = window.URL.createObjectURL(data)
      } catch (err) {
        console.log(err)
      }
    },
    // 点击登录
    async login() {
      let _this = this
      try {
        if (!_this.cardPwd) {
          JmmToast('请输入正确的密码')
          return
        }
        // if(this.codeNum >= 3){
          if (!_this.code) {
            JmmToast('请输入完整的验证码')
            return
          }
        // }
        // 执行登陆接口
        let params = {
          sign: _this.sign,
          card: _this.cardNumber,
          pwd: _this.cardPwd,
          isbind: 1,
          scanLinks: '',
          businessid: '10002',
          imageCode: _this.code,
          channel: 'HUKA',
          // imageCode: this.codeNum <= 3 ? 0 : _this.code,
        }
        const res = await api.user.webBindCard(params)
        if (res.code == '000000') {
        	let jumpUrl = res.data.jumpUrl;
          if(null != jumpUrl && undefined != jumpUrl && '' != jumpUrl){
            window.location.href = jumpUrl;
            return;
          }
          this.showDio = true;
        } else {
          // this.codeNum ++;
          // if(this.codeNum >= 3){
          //   this.getCode();
          // }
          if (res.code == '900000') {
            JmmToast('绑定失败，请稍后重试')
          } else {
            JmmToast(res.message)
            // JmmToast('请输入正确的密码')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 点击扫码 按钮 打开相机
    async getSigncode() {
      try {
         let that = this
         const url = encodeURIComponent(location.href.split("#")[0]); //获取当前页面路由
        //  let url = location.href.split('#')[0]
         const res = await api.user.getSign(url)
          // console.log(res, ' === getSign返回')
        if (res.code == '000000') {
          wx.config({
            debug: false, 
            appId: 'wxc528cd4698883637', // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          })
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success: function(res) {
              //  let result
              // if(res.resultStr.indexOf(',') != -1){
              //   result = res.resultStr.split(',')[1]  // 当needResult 为 1 时，扫码返回的结果
              // }else{
              //   result = res.resultStr
              // }
              // alert(JSON.stringify(result) + '查看===' + JSON.stringify(res.resultStr))
              that.Toscan(res.resultStr)
            },
            fail: function(res) {
              console.log(res)
            }
          });
        }                                                                                                                        
      } catch (error) {
        console.log(error)
        // JmmToast(error)
      }
    },
    // 点击二维码获取
    scancode() {
      this.getSigncode()
    },
    // 扫码接口调用
   async Toscan (can) {
      let info = {
        businessid: '10002',
        sign: this.sign,
        scanLinks:Base64.encode(can),
        isbind: 1,
        card: '',
        pwd: '',
        channel:'HUKA'
      }
      const res = await api.user.cardBindScanLinks(info)
      if (res.code == '000000') {
        let toUrl = `tigerCardLoginList.html#/?merchantId=${this.merchantId}&channel=${this.channel}&timer=${new Date().getTime()}`
        window.location.href = toUrl
      } else {
        JmmToast(res.message)
      }
    }
  },
}
</script>
<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'

.tel_passworld img{
  width: 15px; 
  vertical-align: middle;
  float: right;
}

.webcardbindMain
  width 100%
  height 100%
  overflow hidden
  background #fff
.webcardbindMain .webcardloginHead
  width 100%
  height 50px
  line-height 50px
  text-align center
.webcardbindMain .webcardloginHead .headleft
  float left
  text-align left
  width 70%
  font-size 30px
  height 50px
.webcardbindMain .webcardloginHead .headright
  float right
  text-align right
  width 30%
  font-size 30px
  height 50px
.webwrapCardBody
  width 100%
  height 100%
.webwrapCardBody .Hseat
  height 60px
.webwrapCardBody .telDivCard
  width calc(100% - 150px)
  margin 15px auto
  height 110px
  border-bottom 1px solid #ddd
  i
    font-style normal
    margin-top 30px
    float left
    vertical-align middle
  input
    height 80px
    font-size 45px
    margin-left 20px
    border none
    vertical-align middle
  button
    border 2px solid $codeColor
    width 180px
    height 66px
    font-size 28px
    background $codeColor
    color black
    float right
  img
    width 30% !important
    height 45px !important
    display inline-block
    vertical-align middle
  .pswWidth
    font-size 32px;
    width 50% !important
    display inline
  .pswWidth1
    font-size 32px;
    width 80% !important
    display inline
.loginBtnCard
  width calc(100% - 150px)
  height 90px
  line-height 90px
  margin 0 auto
  background $background
  border-radius 45px
  font-size 34px
  text-align center
  color $color
.agremmentCard
  width calc(100% - 224px)
  margin 32px auto
  font-size 24px
.clearBoth
  clear both
.leftRouter
  float $floLeft
.rightRouter
  float $florRight
.card
  background #fff
  height 100%
input::-webkit-input-placeholder /* WebKit browsers */
  font-size 28px
  line-height normal
input::-moz-input-placeholder /* Mozilla Firefox */
  font-size 28px
  line-height normal
input::-ms-input-placeholder /* Internet Explorer */
  font-size 28px
  line-height normal

  .codeLogin_sao {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// src/view/tigerCardBind/index.vue